import {Routes, Route, useLocation} from 'react-router-dom'
import routes from '../routes'
import Header from '../Header/'
import Footer from '../Footer/'
import { cloneElement, useEffect, useState } from 'react'
import Modal from '../Modal/'
import usePublishedData from '../hooks/usePublishedData'
import './styles.scss'
import MobileModal from '../MobileModal/'
export default function Home(props) {
  const [modal, setModal] = useState()
  const groveData = usePublishedData()
  const location = useLocation()
  const isIndex = location.pathname === '/'
  const [headerVisible, setHeaderVisible] = useState(!isIndex)
  const internalRoutes = routes.filter(route => route.component !== null);

  const toggleModal = (modalWindow) => {
    if (modalWindow === modal) {
      setModal(null)
    } else {
      setModal(modalWindow)
    }
  }
  useEffect(() => {
    if (window.innerWidth < 768) {
      setModal({component: <MobileModal />, label: 'mobile'})
    }
  }, [])
  return (
    <div className='Home'>
      <Header toggleModal={toggleModal} headerVisible={headerVisible} />
      <Routes>
        {
          internalRoutes.map((route, index) => {
            return <Route key={index} exact={route.exact} path={route.path}
              element={cloneElement(route.component, {
                groveData,
                setHeaderVisible,
              })}
            />
          })
        }
      </Routes>
      {modal ? <Modal toggleModal={toggleModal} modal={modal} /> : null}
      <Footer />
    </div>
  )
}
